import React, { createContext, useEffect, useState } from 'react';
import { loadConfig } from '../config/config';

export const BaseUrlContext = createContext();

export const BaseUrlProvider = ({ children }) => {
    const [BaseUrl, setBaseUrl] = useState('');
    const [config, setConfig] = useState(null);
  useEffect(() => {
    const fetchConfig = async () => {
      const loadedConfig = await loadConfig();
      setConfig(loadedConfig);
      setBaseUrl(loadedConfig.ApiUrl);
    };

    fetchConfig();
  }, []);


    return (
        <BaseUrlContext.Provider value={{ BaseUrl, setBaseUrl , config, setConfig}}>
            {children}
        </BaseUrlContext.Provider>
    );
};